import React from 'react';
import { useT } from '@hooks';
import { appStore } from '@store';
import styled from 'styled-components';

import male from './img/male.png';
import female from './img/female.png';

const Container = styled.div`
	margin-top: 30px;
	width: 100%;
	display: flex;
	flex-direction: column;
`;

const Title = styled.h2`
	color: ${({ theme }) => theme.colors.text1};
	font-size: 26px;
	line-height: 32px;
	font-weight: 700;
	text-align: center;
`;

const Description = styled.p`
	margin-top: 15px;
	color: #bcbcbc;
	font-size: 12px;
	font-weight: 300;
	line-height: 14px;
	text-align: left;
`;

const Image = styled.img`
	margin-top: 15px;
	width: 100%;
`;

export const BeforeAfter = () => {
	const { T } = useT();
	const gender = appStore.params.gender;
	return (
		<Container>
			<Title>{T('payment_text_6_22')}</Title>
			{gender === 'male' ? (
				<Image src={male} alt='male before after image' />
			) : (
				<Image src={female} alt='female before after image' />
			)}
			<Description>{T('payment_text_6_23')}</Description>
		</Container>
	);
};
